
export const links = [
  {
    to: "/admin/customer-overview",
    str: "Klantoverzicht",
  },
  {
    to: "/admin/websites",
    str: "Winkel",
  },
  {
    to: "/admin/editor-packages",
    str: "Editor Packages",
  },
  {
    to: "/admin/marketing",
    str: "Marketing",
  },
  {
    to: "/admin/synonyms",
    str: "Synoniemen",
  },
  {
    to: "/admin/discounts",
    str: "Kortingen",
  },
  {
    to: "/admin/accounts",
    str: "Accounts",
  },
  {
    to: "/admin/all-products",
    str: "Alle producten",
  },
  {
    to: "/admin/shop-stocks",
    str: "Winkel Voorraad"
  },
  {
    to: "/admin/brands",
    str: "Merken",
  },
  {
    to: "/admin/suppliers",
    str: "Leveranciers",
  },
  {
    to: "/admin/categories",
    str: "Categorieën",
  },
  {
    to: "/admin/attributes",
    str: "Attributen",
  },
  /* {
    to: "/admin/product-groups",
    str: "Productgroep",
  }, */
  /* {
    to: "/admin/website-products",
    str: "Website Producten",
  }, */
  {
    to: "/admin/wholesale-orders",
    str: "Orderpicken",
  },
  {
    to: "/admin/overview-order",
    str: "Bestellingen",
  },
  {
    to: "/admin/advice-order",
    str: "Besteladvies",
  },
  {
    to: "/admin/replenishment",
    str: "Aanvulling",
  },
  {
    to: "/admin/catalog",
    str: "Catalogus",
  },
  {
    to: "/admin/audit-page",
    str: "Audit pagina",
  },
  {
    to: "/admin/product-settings",
    str: "Product Settings"
  },
  {
    to: "/admin/supplier-orders",
    str: "Supplier Orders"
  }
]

export const getAvailableSitesByRole = role => {
  switch (role) {
    case "EMPLOYEE": {
      return [
        "/admin/websites",
        "/admin/all-products",
        "/admin/catalog",
        "/admin/product/edit/:id",
        "/admin/product/edit",
        "/admin/websites/edit/:id",
        "/admin/wholesale-orders/:id",
        "/admin/websites/edit",
        '/site-editor',
        "/admin/wholesale-orders",
        "/admin/overview-order"
      ]
    }
    case "EXTERNAL": {
      return [
        "/admin/websites",
        "/admin/all-products",
        "/admin/product/edit/:id",
        "/admin/product/edit",
        "/admin/websites/edit/:id",
        "/admin/websites/edit",
        '/site-editor',
        "/admin/overview-order"
      ]
    }
    case "MAINTAINER": {
      return [
        "/admin/websites",
        "/admin/all-products",
        "/admin/catalog",
        "/admin/editor-packages",
        "/admin/product/edit/:id",
        "/admin/product/edit",
        "/admin/websites/edit/:id",
        "/admin/websites/edit",
        "/admin/wholesale-orders",
        "/admin/wholesale-orders/:id",
        "/admin/overview-order"
      ]
    }
  }
}
